"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _BuySellChartOverviewComponent = _interopRequireDefault(require("./BuySellChartOverviewComponent"));
var _instrumentPositionSelectors = require("../../../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var product1 = selectedInstrument.Product1Symbol;
  var product2 = selectedInstrument.Product2Symbol;
  return {
    product1: product1,
    product2: product2
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, null)(_BuySellChartOverviewComponent["default"]);